exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":root {\n  /*\n   * Typography\n   * ======================================================================== */\n\n  --font-family-base: Metropolis, HelveticaNeue-Light, sans-serif;\n\n  /*\n   * Layout\n   * ======================================================================== */\n\n  --max-content-width: 1080px;\n  --max-container-width: 100%;\n\n  /*\n   * Media queries breakpoints\n   * ======================================================================== */\n\n  --screen-xs-min: 480px; /* Extra small screen / phone */\n  --screen-sm-min: 768px; /* Small screen / tablet */\n  --screen-md-min: 992px; /* Medium screen / desktop */\n  --screen-lg-min: 1200px; /* Large screen / wide desktop */\n\n  --primary-dark: #149ce9;\n  --primary: #35baef;\n  --secondary: #f15e26;\n  --gray-medium: #6e6f71;\n  --gray-faded: rgba(0, 0, 0, 0.5);\n  --cool-gray: #a4a7a9;\n  --cool-gray-light: #d9d9d9;\n  --cool-gray-lighter: #c4c4c4;\n  --gray-dark-medium: #585858;\n  --off-white: #fafafa;\n  --gray-dark: #414243;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/components/variables.css
// module id = 2513
// module chunks = 15